import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledSamplesViewGraphFilter = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$6',
  alignItems: 'baseline',
});

export const StyledDateFilterInfo = styled(Box, { display: 'inline-flex', alignItems: 'center' });

export const StyledSelectedRangeText = styled(Box, {
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
  paddingRight: '$4',
});

export const StyledDateRange = styled(Box, {
  marginLeft: '$2',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledSampleTypeFilterText = styled(Box, {
  color: '$darkBlue200',
  fontSize: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});
